export const LEGAL_DOC_VERSIONS = {
  privacy: "2026-05-01",
  terms: "2026-05-01",
  disclaimer: "2026-05-01",
} as const;

export const LEGAL_LAST_UPDATED = "2026-05-01";

export type LegalDocType = keyof typeof LEGAL_DOC_VERSIONS;

export const ALL_LEGAL_DOC_TYPES: LegalDocType[] = ["privacy", "terms", "disclaimer"];
